import { createRef, useEffect } from "react"
import styles from "./Checkbox.module.scss"

type CheckboxProps = {
    onChange?: (event: any) => void
    disabled?: boolean
    checked?: boolean
    id?: any
    name?: any
    required?: any
    indeterminate?: any
    readOnly?: any
}

const Checkbox = (props: CheckboxProps) => {
    const checkboxref = createRef<HTMLInputElement>()

    useEffect(() => {
        if (checkboxref?.current) {
            checkboxref.current.indeterminate = props.indeterminate
        }
    }, [props.indeterminate, props.checked])

    return (
        <div className={styles.checkbox_container}>
            <input
                ref={checkboxref}
                required={props.required}
                id={props.id}
                name={props.name}
                className={styles.checkbox}
                type="checkbox"
                onChange={props.onChange}
                checked={props.checked}
                disabled={props.disabled}
                readOnly={props?.readOnly}
            />
        </div>
    )
}

export default Checkbox
